const mq = ('matchMedia' in window);

const _matchRule = function (rule, debug) {
	const { matches } = window.matchMedia(rule);
	if (debug) {
		console.log(rule, matches ? "Matches" : "NO");
	}
	return matches;
};

const _maxWidth = function (size, debug) {
	return _matchRule(`(max-width: ${size})`, debug);
};

const _minWidth = function (size, debug) {
	return _matchRule(`(min-width: ${size})`, debug);
};

const _matchStringRule = function (rule, debug) {
	return window.matchMedia(rule).matches;
};

const _withinWidth = function (min, max, debug) {
	return _matchRule(`(min-width: ${min}) and (max-width: ${max})`, debug);
};

const MediaQueries = function (config, debug) {
	if (!mq) {
		console.error("matchMedia not supported on this browser");
		return false;
	}

	const defaults = {
		desktop: { min: "1367px" },
		laptop:  { max: "1366px" },
		tablet:  { max: "1024px" },
		mobile:  { max: "480px" },
	};
	this.breakpoints = config || defaults;
	return this;
};

MediaQueries.prototype.matches = function (keyword, debug) {
	let rule;

	if (typeof keyword === 'object') {
		rule = keyword;
	} else {
		rule = this.breakpoints[keyword];
	}

	if (!rule) {
		return -1;
	}

	let _return = false;

	const _try = function (query) {
		if (query.hasOwnProperty('max') && query.hasOwnProperty('min')) {
			return _withinWidth(query.min, query.max, debug);
		}
		if (query.hasOwnProperty('min')) {
			return _minWidth(query.min, debug);
		}
		if (query.hasOwnProperty('max')) {
			return _maxWidth(query.max, debug);
		}
		if (typeof query === "string") {
			return _matchStringRule(query, debug);
		}
		return true;
	};

	if (Array.isArray(rule)) {
		rule.forEach(function (_rule) {
			if (_try(_rule)) {
				_return = true;
			}
		});
	} else {
		_return = _try(rule);
	}

	return _return;
};

export default MediaQueries;
